import { Box, Typography } from '@mui/material';
import { ColorScheme } from '../../Themes/ColorScheme';
import { Spinner } from './Spinner';

const BigButton = ({ text, activity, borderColor, backgroundColor, textColor, action, width, disabled }) => (

        <Box
            sx={{
                border: "1px solid " + (borderColor ? borderColor : ColorScheme.secondary),
                backgroundColor: backgroundColor ? backgroundColor : "transparent",
                height: "40px",
                width: width ? width : "100%",
                opacity: disabled ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                cursor: disabled ? "not-allowed" : "pointer",
                transition: "transform 0.2s ease-in-out",
                '&:hover': {
                    transform: "scale(1.02)"
                }
            }}
            onClick={(!activity && !disabled && action) ? action : undefined}
        >
            {activity ? (
                <Spinner size={"20px"} color={backgroundColor == ColorScheme.secondary ? ColorScheme.primary : ColorScheme.secondary} />
            ) : (
                <Typography sx={{ fontSize: "14px", color: textColor ? textColor : ColorScheme.secondary, fontWeight: "600" }}>
                {text}
                </Typography>
            )}
        </Box>
    );


export default BigButton;